import React from 'react'
import DonatedItem from './donatedItem'
const ListDonated = () => {
  return (
    <div className='animate-fade-in-down'>
      <DonatedItem />
    </div>
  )
}

export default ListDonated